/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var product__slide = document.querySelectorAll('.product__slide');

  for (let index = 0; index < product__slide.length; index++) {
    var deferredMediaPoster = product__slide[index].querySelector('.deferred-media__poster');
  
    if (deferredMediaPoster) {
      deferredMediaPoster.click();
    }
  }
  
  // product page mobile slider arrows start
  const prevBtn = document.querySelector('.prslide_nav.prslide_left');
  const nextBtn = document.querySelector('.prslide_nav.prslide_right');
  
  if (prevBtn) {
    prevBtn.addEventListener('click', prevClick);
    nextBtn.addEventListener('click', nextClick);
  }
  
  function prevClick() {
    var crSlide = document.querySelector('.product__slide.media--active');
    if (crSlide.previousElementSibling) {
      var nxtSlide = document.querySelector('.product__slide');
  
      var prevElementMediaId = crSlide.previousElementSibling.getAttribute('data-media-id');
  
      console.log(prevElementMediaId);
      const $this = document.querySelector('[data-product-thumbs]');
      $this.dispatchEvent(
        new CustomEvent('theme:media:select', {
          bubbles: true,
          detail: {
            id: prevElementMediaId,
          },
        })
      )
    }
  }
  
  function nextClick() {
    var crSlide = document.querySelector('.product__slide.media--active');
    if (crSlide.nextElementSibling) {
      var nxtSlide = document.querySelector('.product__slide');
  
      var nextElementMediaId = crSlide.nextElementSibling.getAttribute('data-media-id');
  
      console.log(nextElementMediaId);
      const $this = document.querySelector('[data-product-thumbs]');
      $this.dispatchEvent(
        new CustomEvent('theme:media:select', {
          bubbles: true,
          detail: {
            id: nextElementMediaId,
          },
        })
      )
    }
  }
  // product page mobile slider arrows end
  
  var bodyElement = document.body;
  if (bodyElement.classList.contains('template-product')) {
    var videoElem = document.querySelector('.media-video');
    var mediaElement = videoElem.closest('.product__media');
    if (videoElem) {
      if (videoElem.paused) {
        mediaElement.removeAttribute('loaded');
      }
    }
  }
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
